import bilAPI from '../api';

export const getMyPlace = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/account_result/my_place/', {
          params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getMyResults = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/account_result/my_results/', {
          params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getListToApprove = (params, signal) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/account_result/list_to_approve/', {
          params,
          signal,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getResults = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/account_result/', {
          params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchResult = (resultUuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/results/account_result/${resultUuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const uploadResultsToCheck = (file, day, location_type) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post('/results/upload_results_file/', { file, day, location_type })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const uploadResultsExcel = (file, round, is_asp) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post('/results/upload_results_file_xlsx/', { file, round, is_asp })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getSchoolPassScore = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/school_pass_score/', {
          params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getRejectReasons = () => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/reason/')
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getResultsStats = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/results_stats_api/', { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getFinalResultsFiles = ({ signal }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/results/final_results/', { signal })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postFinalResultsFiles = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post('/results/final_results/', body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
export const checkFinalResultsFile = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/results/final_results/${uuid}/check/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
export const saveResultsFinalResultsFile = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/results/final_results/${uuid}/save_results`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
export const deleteFinalResultsFiles = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/results/final_results/${uuid}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
